// removed by extract-text-webpack-plugin
module.exports = {"faq":"styles__faq__6YQGH","heading":"styles__heading__3Mfn-","quality-heading":"styles__quality-heading__35nYn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Faq/styles.scss
// module id = 390
// module chunks = 0